export default "__VITE_ASSET__CoU596Ig__"